import React, { useState, useEffect } from 'react';
import { Element, scroller } from 'react-scroll';
import { searchContext } from '../../Context/Context.jsx';
import ManageGrid from '../../modules/search/searchGrid/components/table/ManageGrid';
import { Columns } from '../Table/Columns.jsx';

function MappingResults({ mappingContent, dispatch }) {
  const { view, source, tab, setSearchItems } = searchContext();
  const [isInfoSidebarOpen, setIsInfoSidebarOpen] = useState(false);

  const title = Columns().find(c => c.name === mappingContent.name)?.header;

  const getDefaultEvidenceFilterValue = mappingContent => {
    if (!mappingContent) return undefined;
    if (mappingContent.name === 'numPMIDsupportingAssociation') {
      return [
        {
          name: 'reference_type',
          operator: 'contains',
          type: 'string',
          value: 'PMID',
        },
      ];
    }
    if (mappingContent.name === 'numCTsSupportingAssociation') {
      return [
        {
          name: 'reference_type',
          operator: 'contains',
          type: 'string',
          value: 'NCTID',
        },
      ];
    }
    return undefined;
  };

  const showSummary = true;
  const showEvidence = true;

  useEffect(() => {
    scroller.scrollTo('MappingSummary', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
  }, [mappingContent]);

  return (
    <>
      <div className="titEtiqueta pt-12">
        <span>{title} Mapping</span>
      </div>
      <Element name="MappingSummary">
        {showSummary && mappingContent?.mappingItems && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={false}
            isMapping={true}
            isInfoSidebarOpen={isInfoSidebarOpen}
            mappingContent={mappingContent}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            dispatch={dispatch}
          />
        )}
      </Element>
      <Element name="MappingEvidence">
        {showEvidence && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={true}
            isMapping={true}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            mappingContent={mappingContent}
            isInfoSidebarOpen={isInfoSidebarOpen}
            dispatch={dispatch}
            defaultFilterValue={getDefaultEvidenceFilterValue(mappingContent)}
          />
        )}
      </Element>
    </>
  );
}
export default MappingResults;
